import moment from 'moment';

const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const RESET_CODE_REGEXP = /^[A-Z]{2}[0-9]-[0-9]{3}-[A-Z]{2}$/;
const PASSWORD_STRENGTH_REGEXP = /^^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])(?=.{8,})/;
const NAME_REGEXP = /^([a-zA-ZÀ-ú\-\']|[ ]{1}[^ ])*$/;

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 30;
export const FIRST_NAME_MAX_LENGTH = 30;
export const LAST_NAME_MAX_LENGTH = 35;

export function checkEmail(email) {
  return EMAIL_REGEXP.test(email);
}

export function checkResetCode(code) {
  return RESET_CODE_REGEXP.test(code);
}

export function checkPasswordStrenth(password) {
  return PASSWORD_STRENGTH_REGEXP.test(password);
}

export function checkPasswordMinLength(password) {
  return password.length >= PASSWORD_MIN_LENGTH;
}

export function checkPasswordMaxLength(password) {
  return password.length <= PASSWORD_MAX_LENGTH;
}

export function checkFirstNameMaxLength(firstName) {
  return firstName.length <= FIRST_NAME_MAX_LENGTH;
}

export function checkFirstNameRegex(firstName) {
  return NAME_REGEXP.test(firstName);
}

export function checkLastNameMaxLength(lastName) {
  return lastName.length <= LAST_NAME_MAX_LENGTH;
}

export function checkLastNameRegex(lastName) {
  return NAME_REGEXP.test(lastName)
}

export function checkBirthDate(birthDate) {
  let currentPosition = birthDate.length;
  const inputDate = moment(birthDate, 'DD/MM/YYYY');

  if (currentPosition !== 10) {
    return;
  }
  var dateR = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
  return (/*dateR.test(inputDate) &&*/ inputDate.isValid());
}

export function checkAge(birthDate) {
  const birthDateObject = moment(birthDate, 'DD/MM/YYYY');
  const age = moment().diff(birthDateObject, 'years');

  return age >= 18;
}



// WEBPACK FOOTER //
// ./src/helpers/field-checker.helper.js